import React, { useRef } from "react";
import { useForm } from "react-hook-form";
import Images from "../assets/Image";
import emailjs from "@emailjs/browser";
const ContactUsSidebar = () => {
  const {
    formState: { errors },
    register,
    handleSubmit,
  } = useForm();
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_520oyz9", "template_xr5ts3y", form.current, {
        publicKey: "YI1Dlv7k1QHWv_o9e",
      })
      .then(
        () => {
          console.log("SUCCESS!");
          alert("form submitted successfully..");
        },
        (error) => {
          console.log("FAILED...", error.text);
        },
      );
  };
  return (
    <>
      <div className="automobile_industry_continuous_inkjet_printers_right">
        <div className="contactusImageSection">
          <div className="contactusImageContainer">
            <div className="contactusImageBlock">
              <img src={Images?.contactus} className="image_icon" />
            </div>
            <h6 className="contactus_title">CONTACT US</h6>
          </div>
          <div style={{ position: "absolute", bottom: "0px" }}>
            <img src={Images?.contactusBottom} className="image_icon" />
          </div>
        </div>
        <form ref={form} onSubmit={sendEmail}>
          <div className="my-3">
            <input
              type="text"
              className="automobile_input_field"
              {...register("uname")}
              placeholder="Name"
              required
            />
          </div>
          <div className="my-3">
            <input
              type="email"
              className="automobile_input_field"
              {...register("emailID")}
              placeholder="Email ID"
              required
            />
          </div>
          <div className="my-3">
            {" "}
            <input
              type="tel"
              className="automobile_input_field"
              {...register("mobileNumber")}
              placeholder="Mobile Number"
              required
            />
          </div>
          <div className="my-3">
            <input
              type="text"
              className="automobile_input_field"
              {...register("need")}
              placeholder="Need"
              required
            />
          </div>
          <div className="my-3">
            <textarea
              className="automobile_input_field"
              {...register("message")}
              placeholder="What is your need"
              required
            ></textarea>
          </div>
          <div
            className="my-3"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <button className="contactUsSubmitBtn">Submit Now</button>
          </div>
        </form>
        <iframe
          width="100%"
          height="150px"
          src="https://www.youtube.com/embed/jMFx1pUakkU"
          title="co pilot max2 movie"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
          className="automobile_link_tab"
        ></iframe>
        <iframe
          width="100%"
          height="150px"
          src="https://www.youtube.com/embed/jMFx1pUakkU"
          title="co pilot max2 movie"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
          className="automobile_link_tab"
        ></iframe>
        <iframe
          width="100%"
          height="150px"
          src="https://www.youtube.com/embed/jMFx1pUakkU"
          title="co pilot max2 movie"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
          className="automobile_link_tab"
        ></iframe>
      </div>
    </>
  );
};

export default ContactUsSidebar;
